import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { OverviewSection } from "./components/OverviewSection";
import { ServicesSection } from "./components/ServicesSection";
import { WhyChooseSection } from "./components/WhyChooseSection";
import { ProcessSection } from "./components/ProcessSection";
import { PricingSection } from "./components/PricingSection";
import { IndustriesSection } from "./components/IndustriesSection";
import { BenefitsSection } from "./components/BenefitsSection";
import { FAQSection } from "./components/FAQSection";
import { CTASection } from "./components/CTASection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { ContactPopup } from "./components/ContactPopup";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { TermsConditions } from "./components/TermsConditions";
import { Toaster } from "./components/ui/sonner";

const HomePage = ({ onContactClick }) => {
  return (
    <>
      <HeroSection onContactClick={onContactClick} />
      <AboutSection />
      <OverviewSection onContactClick={onContactClick} />
      <ServicesSection onContactClick={onContactClick} />
      <WhyChooseSection />
      <ProcessSection />
      <PricingSection onContactClick={onContactClick} />
      <IndustriesSection />
      <BenefitsSection />
      <FAQSection />
      <CTASection onContactClick={onContactClick} />
      <ContactSection onContactClick={onContactClick} />
    </>
  );
};

function App() {
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);

  const handleContactClick = () => {
    setIsContactPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsContactPopupOpen(false);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Navbar onContactClick={handleContactClick} />
        
        <main>
          <Routes>
            <Route path="/" element={<HomePage onContactClick={handleContactClick} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>
        </main>

        <Footer onContactClick={handleContactClick} />
        <ContactPopup isOpen={isContactPopupOpen} onClose={handleClosePopup} />
      </BrowserRouter>
    </div>
  );
}

export default App;
